import staffMemberSlice from './staffMemberSlice.js';
//import itemGradesCountSlice from './items-grades-counts/ItemsGradesCountSettingSlice.js';

const adminSlices = {
    staffMemberSetting: staffMemberSlice
};

export default adminSlices;